var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg41(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1890,
    height: 512,
    viewBox: "0 0 1890 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M659.208 356.467C697.793 356.467 724.989 334.454 724.989 300.755C725.261 271.682 707.786 254.826 678.637 244.231L658.651 236.893C638.394 229.556 628.674 223.307 628.674 209.177C628.674 195.046 643.106 186.896 659.765 186.896C675.31 186.896 687.244 193.145 697.237 204.83L719.72 183.361C705.288 166.239 684.474 157 660.049 157C623.405 157 595.938 177.658 595.938 211.356C595.938 237.717 611.199 254.56 642.562 265.712L664.217 273.317C683.089 280.11 692.253 288.804 692.253 302.668C692.253 317.065 678.934 326.583 660.333 326.583C641.177 326.583 624.803 317.344 614.538 301.857L589 321.691C600.637 342.603 627.561 356.467 659.208 356.467ZM813.376 355.922C842.526 355.922 864.168 343.959 876.659 324.403L853.347 308.093C845.852 320.056 833.362 328.75 813.661 328.75C790.349 328.75 772.305 314.353 770.92 291.794H879.998C880.27 287.447 880.27 285.001 880.27 282.011C880.27 238.262 850.02 214.613 813.376 214.613C771.192 214.613 740.93 245.321 740.93 285.268C740.93 326.837 771.18 355.922 813.376 355.922ZM772.293 270.047C776.733 249.935 794.22 239.884 812.263 239.884C830.022 239.884 846.124 250.479 849.451 270.047H772.293ZM1038.88 410V217.326H1008.34V235.537C1000.58 224.664 983.919 214.613 963.933 214.613C925.904 214.613 897.04 246.411 897.04 285.268C897.04 324.125 925.904 355.922 963.933 355.922C983.919 355.922 1000.58 345.872 1008.34 334.998V410H1038.88ZM969.486 328.738C945.061 328.738 928.131 309.715 928.131 285.256C928.131 260.796 945.061 241.773 969.486 241.773C993.911 241.773 1010.84 260.796 1010.84 285.256C1010.84 309.715 993.911 328.738 969.486 328.738ZM1117.88 355.922C1135.64 355.922 1150.35 348.584 1158.41 334.72V353.198H1188.94V217.326H1158.41V284.178C1158.41 313.53 1144.53 328.75 1124.54 328.75C1106.79 328.75 1096.79 315.431 1096.79 293.696V217.326H1066.26V298.587C1066.26 333.364 1085.96 355.922 1117.88 355.922ZM1284.43 355.922C1313.58 355.922 1335.22 343.959 1347.71 324.403L1324.4 308.093C1316.9 320.056 1304.41 328.75 1284.71 328.75C1261.4 328.75 1243.36 314.353 1241.97 291.794H1351.05C1351.32 287.447 1351.32 285.001 1351.32 282.011C1351.32 238.262 1321.07 214.613 1284.43 214.613C1242.24 214.613 1211.98 245.321 1211.98 285.268C1211.98 326.837 1242.23 355.922 1284.43 355.922ZM1243.34 270.047C1247.78 249.935 1265.27 239.884 1283.31 239.884C1301.07 239.884 1317.17 250.479 1320.5 270.047H1243.34ZM1374.37 353.198H1404.91V286.346C1404.91 256.994 1420.45 241.773 1440.71 241.773C1458.47 241.773 1469.57 254.548 1469.57 276.283V353.186H1500.11V271.391C1500.11 236.881 1479.29 214.589 1447.09 214.589C1429.05 214.589 1413.5 221.927 1404.91 235.792V217.326H1374.37V353.198ZM1594.12 355.922C1622.99 355.922 1646.86 341.247 1658.79 318.422L1632.14 304.291C1625.47 318.155 1611.88 328.205 1594.11 328.205C1569.41 328.205 1551.93 309.449 1551.93 285.268C1551.93 261.087 1569.41 242.33 1594.11 242.33C1611.87 242.33 1625.47 252.381 1632.14 266.245L1658.79 252.114C1646.86 229.289 1622.99 214.613 1594.12 214.613C1552.5 214.613 1520.85 245.055 1520.85 285.268C1520.85 325.481 1552.5 355.922 1594.12 355.922ZM1741.11 355.922C1770.26 355.922 1791.9 343.959 1804.39 324.403L1781.08 308.093C1773.58 320.056 1761.09 328.75 1741.39 328.75C1718.07 328.75 1700.04 314.353 1698.64 291.794H1807.73C1808 287.447 1808 285.001 1808 282.011C1808 238.262 1777.75 214.613 1741.11 214.613C1698.91 214.613 1668.66 245.321 1668.66 285.268C1668.66 326.837 1698.91 355.922 1741.11 355.922ZM1700.02 270.047C1704.46 249.935 1721.95 239.884 1739.99 239.884C1757.75 239.884 1773.85 250.479 1777.18 270.047H1700.02Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97 164.505L97 347.165C97 384.447 127.14 414.67 164.32 414.67H425.68C462.86 414.67 493 384.447 493 347.165V164.505C493 127.223 462.86 97.0001 425.68 97.0001H164.32C127.14 97.0001 97 127.223 97 164.505Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 164.505L97 347.165C97 384.447 127.14 414.67 164.32 414.67H425.68C462.86 414.67 493 384.447 493 347.165V164.505C493 127.223 462.86 97.0001 425.68 97.0001H164.32C127.14 97.0001 97 127.223 97 164.505Z",
    fill: "url(#paint0_linear_11_117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 176.418C196 165.452 187.135 156.563 176.2 156.563C165.265 156.563 156.4 165.452 156.4 176.418C156.4 187.383 165.265 196.272 176.2 196.272C187.135 196.272 196 187.383 196 176.418Z",
    fill: "url(#paint1_linear_11_117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 176.418C196 165.452 187.135 156.563 176.2 156.563C165.265 156.563 156.4 165.452 156.4 176.418C156.4 187.383 165.265 196.272 176.2 196.272C187.135 196.272 196 187.383 196 176.418Z",
    fill: "url(#paint2_linear_11_117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 176.418C196 165.452 187.135 156.563 176.2 156.563C165.265 156.563 156.4 165.452 156.4 176.418C156.4 187.383 165.265 196.272 176.2 196.272C187.135 196.272 196 187.383 196 176.418Z",
    fill: "url(#paint3_linear_11_117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 335.126C196 324.161 187.135 315.272 176.2 315.272C165.265 315.272 156.4 324.161 156.4 335.126C156.4 346.092 165.265 354.981 176.2 354.981C187.135 354.981 196 346.092 196 335.126Z",
    fill: "url(#paint4_linear_11_117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.6 255.835C433.6 244.87 424.735 235.981 413.8 235.981C402.865 235.981 394 244.87 394 255.835C394 266.8 402.865 275.69 413.8 275.69C424.735 275.69 433.6 266.8 433.6 255.835Z",
    fill: "url(#paint5_linear_11_117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.6 255.835C433.6 244.87 424.735 235.981 413.8 235.981C402.865 235.981 394 244.87 394 255.835C394 266.8 402.865 275.69 413.8 275.69C424.735 275.69 433.6 266.8 433.6 255.835Z",
    fill: "url(#paint6_linear_11_117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.8 156.563H255.4C244.465 156.563 235.6 165.452 235.6 176.418C235.6 187.383 244.465 196.272 255.4 196.272H413.8C424.735 196.272 433.6 187.383 433.6 176.418C433.6 165.452 424.735 156.563 413.8 156.563Z",
    fill: "url(#paint7_linear_11_117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.8 315.272H255.4C244.465 315.272 235.6 324.161 235.6 335.126C235.6 346.092 244.465 354.981 255.4 354.981H413.8C424.735 354.981 433.6 346.092 433.6 335.126C433.6 324.161 424.735 315.272 413.8 315.272Z",
    fill: "url(#paint8_linear_11_117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6 235.981H176.2C165.265 235.981 156.4 244.87 156.4 255.835C156.4 266.8 165.265 275.69 176.2 275.69H334.6C345.535 275.69 354.4 266.8 354.4 255.835C354.4 244.87 345.535 235.981 334.6 235.981Z",
    fill: "url(#paint9_linear_11_117)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_117",
    x1: 295,
    y1: 97.0001,
    x2: 295,
    y2: 415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D273D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0F13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_117",
    x1: 162.5,
    y1: 196,
    x2: 189.5,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D69FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_117",
    x1: 159.88,
    y1: 196.291,
    x2: 193.138,
    y2: 194.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3757FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11_117",
    x1: 159.88,
    y1: 196.291,
    x2: 193.138,
    y2: 194.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2447FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11_117",
    x1: 162,
    y1: 348.5,
    x2: 188.5,
    y2: 320.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC3EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D972F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11_117",
    x1: 402,
    y1: 269,
    x2: 426.5,
    y2: 243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E7FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11_117",
    x1: 397.18,
    y1: 275.418,
    x2: 431.567,
    y2: 273.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11_117",
    x1: 251.5,
    y1: 196,
    x2: 414.5,
    y2: 157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11_117",
    x1: 253,
    y1: 355,
    x2: 409.5,
    y2: 315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2447FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11_117",
    x1: 183,
    y1: 276,
    x2: 332.5,
    y2: 236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6634FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C6DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 317.67,
    fill: "white",
    transform: "translate(97 97)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg41);
export default __webpack_public_path__ + "static/media/41.70c52c924383f28cca57bbd95c3c2442.svg";
export { ForwardRef as ReactComponent };